import React from 'react'
import {injectIntl} from 'react-intl'

const notificationTypeToClassNameMap = {
  'warn': 'alert-warning',
  'success': 'alert-success',
  'error': 'alert-danger',
  'info': 'alert-info',
}

const notificationTypeToClassName = type => {
  const defaultValue = notificationTypeToClassNameMap['info']
  const value = notificationTypeToClassNameMap[type]
  return value ? value : defaultValue
}

class Notification extends React.Component {
  componentDidMount(){
    this.timerId = setTimeout(this.props.onClose, this.props.duration)
  }
  componentWillUnmount(){
    if(this.timerId){
      clearTimeout(this.timerId)
      this.timerId = null
    }
  }
  render(){
    const {title, message, type, onClose, intl} = this.props
    return <div className={`alert ${notificationTypeToClassName(type)}`}>
      <button type="button" className="close" onClick={onClose}>
        <span aria-hidden="true">&times;</span>
      </button>
      <strong>{intl.formatMessage(title)}</strong>
      <p>
      {intl.formatMessage(message)}
    </p>
    </div>
  }
}

const ReactIntlMessageDescriptor = React.PropTypes.shape({
    id: React.PropTypes.string.isRequired,
    defaultMessage: React.PropTypes.string,
    description: React.PropTypes.string,
})
 
Notification.propTypes = {
  id: React.PropTypes.string.isRequired,
  duration: React.PropTypes.number,
  type: React.PropTypes.oneOf(["success", "warn", "error", "info"]).isRequired,
  title: ReactIntlMessageDescriptor.isRequired, // this field should be a react-intl message
  message: ReactIntlMessageDescriptor.isRequired, // this field should be a react-intl message
  onClose: React.PropTypes.func.isRequired,
}
Notification.defaultProps = {
  duration: 10000
}
export default injectIntl(Notification)



/** WEBPACK FOOTER **
 ** ./app/components/Notification.jsx
 **/